import { Link } from "react-router-dom";
import { ExplainerVideo } from "../../components/ExplainerVideo";
import { InfoLayout } from "../../components/InfoLayout";

export function HowItWorksPage() {
  return (
    <InfoLayout
      title="How it works"
      lead="PyDialog follows a simple loop: read, explain, get real feedback. You're never asked to tick a box — you show what you understand in your own words."
    >
      <ExplainerVideo
        src="/videos/how-it-works-learners.mp4"
        captions="/videos/how-it-works-learners.vtt"
        poster="/videos/how-it-works-learners.jpg"
        title="How PyDialog works for learners"
        caption="A 90-second tour: sign up, study a lesson, explain your answers, and track your progress."
      />

      <div className="card">
        <h3>1 · Read the lesson</h3>
        <p>
          Each lesson gives you the full explanation, worked examples, and — for
          Mathematics — accurate graphs and diagrams rendered by a real geometry
          engine (not hand-drawn approximations). You read it at your own pace.
        </p>
      </div>

      <div className="card">
        <h3>2 · Test your knowledge in a dialogue</h3>
        <p>
          When you're ready, you start a dialogue. It asks focused questions, one
          concept at a time, and you answer in plain sentences. There's no single
          "right" wording — you explain your reasoning the way you'd explain it to
          a friend.
        </p>
      </div>

      <div className="card">
        <h3>3 · Get graded on genuine understanding</h3>
        <p>
          Your answers are assessed for real comprehension at the right level of
          difficulty. Correct explanations are rewarded even when you paraphrase;
          simply repeating keywords without understanding is not. Where you've
          misunderstood something, it's named specifically so you can fix it.
        </p>
      </div>

      <div className="card">
        <h3>4 · See where you stand and try again</h3>
        <p>
          After each dialogue you get a summary: your strengths, the concepts that
          need more work, and clear next steps. Progress is tracked per objective,
          and you can revisit a lesson to strengthen the parts that need it.
        </p>
        <p>
          <Link to="/mastery">See how progress &amp; mastery are measured →</Link>
        </p>
      </div>
    </InfoLayout>
  );
}
